import React from 'react'
import Logo from '../../assets/logo-short-new.svg'

export default () => (
  <Logo />
)
